import { render, staticRenderFns } from "./LandmarkSelectionView.vue?vue&type=template&id=019d4d13&scoped=true"
import script from "./LandmarkSelectionView.vue?vue&type=script&lang=ts"
export * from "./LandmarkSelectionView.vue?vue&type=script&lang=ts"
import style0 from "./LandmarkSelectionView.vue?vue&type=style&index=0&id=019d4d13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d4d13",
  null
  
)

export default component.exports